<template>
    <div class="reminder-card">
        <div v-for="(data, idx) in dataList" :key="`${idx}-reminder`" class="m-d-12">
            <SOSlotCard :id="`reminder-${idx}`" :card-type="typeCard" :dropdown-menu="`card`">
                <template v-slot:card_head>
                    <div class="d-flex-between-center">
                        <div class="">
                            <span>{{ getReminder(data).nama }}</span>
                        </div>
                        <div>
                            <SOIconBase view-box="0 0 24 24" width="24" height="24">
                                <template v-slot:icon>
                                    <MoreMenu2424 />
                                </template>
                            </SOIconBase>
                        </div>
                    </div>
                </template>
                <template v-slot:menu_card>
                    <div>
                        <button class="dropdown-item icon-2" @click="goEdit(data)">
                            <SOIconBase view-box="0 0 20 21" width="20" height="21">
                                <template v-slot:icon>
                                    <EditPencil2021 />
                                </template>
                            </SOIconBase>
                            Ubah
                        </button>
                        <button class="dropdown-item icon-2" @click="goDelete(data)">
                            <SOIconBase view-box="0 0 20 20" width="20" height="21">
                                <template v-slot:icon>
                                    <Trash2020 icon-fill="#EB5757" />
                                </template>
                            </SOIconBase>
                            Hapus
                        </button>
                    </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import MoreMenu2424 from "@/so-components/global/icons/iconPacks/MoreMenu2424.vue";
import EditPencil2021 from "@/so-components/global/icons/iconPacks/EditPencil2021.vue";
import Trash2020 from "@/so-components/global/icons/iconPacks/Trash2020.vue";

import { moduleName } from "../store/state";

export default {
    name: "CardReminder",
    props: {
        typeCard: {
            type: String,
            default: "box",
        },
        dataList: {
            type: Array,
            default: function() {
                return [];
            },
        },
    },
    components: {
        SOSlotCard,
        SOIconBase,
        MoreMenu2424,
        EditPencil2021,
        Trash2020,
    },
    computed: {
        ...mapGetters({
            reminderOption: `pengaturanUmumModule/reminderOption`,
        }),
        getReminder() {
            return (id) => {
                return this.reminderOption.find((rm) => rm.id === parseInt(id));
            };
        },
    },
    methods: {
        ...mapActions({
            removeReminders: `${moduleName}/removeReminders`,
        }),
        goEdit(data) {
            this.$router.push({ name: "invoice.create.update_pengingat", params: { id: data } });
        },
        goDelete(data) {
            this.removeReminders(data);
        },
    },
};
</script>
<style scoped src="../static/style.css"></style>
